import React, { useMemo } from 'react';
import AsyncSelect from 'react-select/async';
import api from '../../services/api';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
    '&:hover': { borderColor: '#9ca3af' },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#2563eb' : state.isFocused ? '#eff6ff' : 'white',
    color: state.isSelected ? 'white' : '#111827',
    cursor: 'pointer',
  }),
};

const formatOptionLabel = (option) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 py-0.5">
    <span className="font-medium">
      {option.inscription.nom} {option.inscription.prenom}
    </span>
    <span className="text-xs text-gray-500">
      {option.inscription.matricule}
      {option.inscription.classe_nom ? ` — ${option.inscription.classe_nom}` : ''}
    </span>
  </div>
);

const InscriptionSelect = ({ selectedYear, value, onChange, isDisabled = false }) => {
  const selectedOption = useMemo(() => {
    if (!value) return null;
    return {
      value: value.id,
      label: `${value.nom} ${value.prenom}`,
      inscription: value,
    };
  }, [value]);

  const loadOptions = async (inputValue) => {
    if (!selectedYear?.id) return [];

    const params = {
      annee_scolaire_id: selectedYear.id,
      limit: inputValue?.trim().length >= 2 ? 30 : 50,
    };
    if (inputValue?.trim().length >= 2) {
      params.search = inputValue.trim();
    }

    const res = await api.get('/inscriptions', { params });
    return (res.data.data || []).map((insc) => ({
      value: insc.id,
      label: `${insc.nom} ${insc.prenom}`,
      inscription: insc,
    }));
  };

  if (!selectedYear?.id) {
    return (
      <p className="text-sm text-orange-600 mt-1">
        Sélectionnez une année scolaire pour rechercher un élève.
      </p>
    );
  }

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      value={selectedOption}
      onChange={(opt) => onChange(opt ? opt.inscription : null)}
      isClearable
      isDisabled={isDisabled}
      placeholder="Rechercher par nom, prénom ou matricule..."
      noOptionsMessage={({ inputValue }) =>
        inputValue.length < 2
          ? 'Tapez au moins 2 caractères ou parcourez la liste'
          : 'Aucun élève trouvé pour cette année'
      }
      loadingMessage={() => 'Recherche en cours...'}
      formatOptionLabel={formatOptionLabel}
      classNamePrefix="react-select"
      styles={selectStyles}
    />
  );
};

export default InscriptionSelect;
